<template>
  <div
    role="tablist"
    aria-label="Choose power type"
    class="calculator-segmented-buttons"
  >
    <button
      v-for="(option, index) in existingOptions"
      ref="buttons"
      role="tab"
      v-show="option?.label !== '' && option?.value !== ''"
      class="calculator-segmented-buttons__segment"
      :class="`${option.value === selectedValue ? 'calculator-segmented-buttons__segment--selected' : ''}`"
      :key="`${uid}-${option.value}`"
      :tabindex="option.value === selectedValue ? 0 : -1"
      :aria-selected="option.value === selectedValue"
      :aria-controls="`${uid}-tabpanel-${option.value}`"
      :id="`${uid}-tab-${option.value}`"
      @keydown.enter="option.value && toggleOption(option.value)"
      @keydown.arrow-right="moveFocusToNextOption"
      @keydown.arrow-left="moveFocusToPreviousOption"
      @click="option.value && toggleOption(option.value)"
      @focus="handleFocus(option)"
    >
      <span class="calculator-segmented-buttons__segment-label">
        {{ option.label }}
      </span>
    </button>
  </div>
</template>

<script setup>
import './CalculatorSegmentedButtons.scss';
import { computed, ref } from 'vue';

const buttons = ref([]);
const props = defineProps({
  options: {
    type: Array,
    default: () => [],
    required: true,
  },
  selectedValue: {
    type: String,
    default: '01',
    required: true,
  },
  uid: {
    type: String,
    default: '',
  },
});

const existingOptions = computed(() =>
  props.options.filter((option) => option.label !== ''),
);

const emit = defineEmits(['update:selectedValue']);

const handleFocus = (option) => {
  if (option.value !== props.selectedValue) {
    toggleOption(option.value);
  }
};

const toggleOption = (value) => {
  emit('update:selectedValue', value);
};

const moveFocusToNextOption = () => {
  let idx = existingOptions.value.findIndex(
    (option) => option.value === props.selectedValue,
  );
  if (idx < existingOptions.value.length - 1) {
    idx++;
  } else {
    idx = 0;
  }

  buttons.value[idx]?.focus();
  toggleOption(existingOptions.value[idx].value);
};

const moveFocusToPreviousOption = () => {
  let idx = existingOptions.value.findIndex(
    (option) => option.value === props.selectedValue,
  );
  if (idx > 0) {
    idx--;
  } else {
    idx = existingOptions.value.length - 1;
  }

  buttons.value[idx]?.focus();
  toggleOption(existingOptions.value[idx].value);
};
</script>
